"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/*
  The MIT License

  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var react_1 = tslib_1.__importDefault(require("react"));
var core_1 = require("@material-ui/core");
var AppBar_1 = tslib_1.__importDefault(require("@material-ui/core/AppBar"));
var core_2 = require("@jsonforms/core");
var react_2 = require("@jsonforms/react");
var layout_1 = require("../util/layout");
exports.isSingleLevelCategorization = core_2.and(core_2.uiTypeIs('Categorization'), function (uischema) {
    var categorization = uischema;
    return (categorization.elements &&
        categorization.elements.reduce(function (acc, e) { return acc && e.type === 'Category'; }, true));
});
exports.materialCategorizationTester = core_2.rankWith(1, exports.isSingleLevelCategorization);
var MaterialCategorizationLayoutRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(MaterialCategorizationLayoutRenderer, _super);
    function MaterialCategorizationLayoutRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            activeCategory: 0
        };
        _this.hasOwnState = function () {
            return _this.props.ownState !== undefined ? _this.props.ownState : true;
        };
        _this.handleChange = function (_event, value) {
            if (_this.props.onChange) {
                _this.props.onChange(value, _this.state.activeCategory);
            }
            var hasOwnState = _this.hasOwnState();
            if (hasOwnState) {
                _this.setState({ activeCategory: value });
            }
        };
        return _this;
    }
    MaterialCategorizationLayoutRenderer.prototype.render = function () {
        var _a = this.props, data = _a.data, path = _a.path, renderers = _a.renderers, cells = _a.cells, schema = _a.schema, uischema = _a.uischema, visible = _a.visible, enabled = _a.enabled, selected = _a.selected, ajv = _a.ajv;
        var categorization = uischema;
        var value = this.hasOwnState() ? this.state.activeCategory : selected;
        var childProps = {
            elements: categorization.elements[value].elements,
            schema: schema,
            path: path,
            direction: 'column',
            enabled: enabled,
            visible: visible,
            renderers: renderers,
            cells: cells
        };
        var categories = categorization.elements.filter(function (category) {
            return core_2.isVisible(category, data, undefined, ajv);
        });
        return (react_1.default.createElement(core_1.Hidden, { xsUp: !visible },
            react_1.default.createElement(AppBar_1.default, { position: 'static' },
                react_1.default.createElement(core_1.Tabs, { value: value, onChange: this.handleChange, variant: 'scrollable' }, categories.map(function (e, idx) { return (react_1.default.createElement(core_1.Tab, { key: idx, label: e.label })); }))),
            react_1.default.createElement("div", { style: { marginTop: '0.5em' } },
                react_1.default.createElement(layout_1.MaterialLayoutRenderer, tslib_1.__assign({}, childProps)))));
    };
    return MaterialCategorizationLayoutRenderer;
}(react_2.RendererComponent));
exports.MaterialCategorizationLayoutRenderer = MaterialCategorizationLayoutRenderer;
exports.default = react_2.withJsonFormsLayoutProps(layout_1.withAjvProps(MaterialCategorizationLayoutRenderer));
//# sourceMappingURL=MaterialCategorizationLayout.js.map